<app-compliance-nav [activeMenuItem]="'riskDormantCards'"></app-compliance-nav>

<mat-card>
  <app-mat-table-generator #table
                           tableName="riskDormantCardsTable"
                           [useEmbededFilter]="false"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [editEnabled]="false"
                           [deleteEnabled]="false"
                           [multiselectEnabled]="false"
                           [rowClassCallback]="getRowClass"
                           [viewLink]="getCustomerOverviewLink"
  >
  </app-mat-table-generator>

</mat-card>

